<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				ref='table'
				border
				stripe
				show-summary
				:summary-method="summmaryMethod"
				:height="tableHeight"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				@sort-change='sortChangeHandle'
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="staffname"
					label="员工姓名"
					fixed="left"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customername"
					label="客户"
					fixed="left"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.customername}}</div>
						<div>{{scope.row.customercategoryname}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productname"
					label="提成商品"
					fixed="left"
					align="center">
					<template slot-scope="scope">
						<div :title="scope.row.productname" class="product-name"><div v-if="scope.row.giftflag" class="giftLogo">赠</div><div class="p-name">{{scope.row.productname}}</div></div>
						<div>{{scope.row.productspec}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="productprice"
					label="单价/数量"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.productprice}} x {{scope.row.productcount}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="realpaymoney"
					sortable="custom"
					label="实付金额"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.realpaymoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionrules"
					label="提成规则"
					align="center">
				</el-table-column>
				<el-table-column
					prop="commissionmoney"
					sortable="custom"
					label="提成金额"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.commissionmoney}}</div>
						<div v-if="scope.row.liquiDateFlag">已勾销</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordernumber"
					label="关联单"
					align="center"
					width="220">
					<template slot-scope="scope">
						<div @click="goOrderDetail(scope.row)" class="under-num">{{scope.row.ordernumber}}</div>
						<div @click="goRefundOrderDetail(item)" class="under-num1" v-for="item in scope.row.refundnumberList" :key="item.refundid"><span>{{item.refundnumber}}</span><div class="return-icon">退</div></div>
					</template>
				</el-table-column>
				<el-table-column
					prop="createdate"
					sortable="custom"
					label="生成时间"
					align="center"
					width="104">
				</el-table-column>
				<el-table-column
					prop="ordercreatedate"
					sortable="custom"
					label="下单时间"
					align="center"
					width="104">
				</el-table-column>
				<el-table-column
					prop="liquidatedate"
					sortable="custom"
					label="勾销时间"
					align="center"
					width="104">
				</el-table-column>
				<el-table-column
					prop="auditingdate"
					sortable="custom"
					label="审核时间"
					align="center"
					width="104">
				</el-table-column>
				<el-table-column label="操作" width="150" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="liquidate(scope.row, 1)" v-if="AuthorityList['11_0002_0003_00'] && !scope.row.liquiDateFlag">勾销</el-button>
						<el-button type='text' size="mini" @click="liquidate(scope.row, 0)" v-if="AuthorityList['11_0002_0003_00'] && scope.row.liquiDateFlag">取消勾销</el-button>
						<el-button type='text' size="mini" @click="auditing(scope.row, 0)" v-if="AuthorityList['11_0002_0003_00'] && scope.row.auditingFlag">已审核</el-button>
						<el-button type='text' size="mini" @click="auditing(scope.row, 1)" v-if="AuthorityList['11_0002_0003_00'] && !scope.row.auditingFlag">未审核</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			realpaymoneySum: 0,
			commissionmoneySum: 0,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			})
		}
	},
	watch: {
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(val, this.$refs.table)
				})
			},
			immediate: true
		}
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
		this.getSum()
	},
	methods: {
		clear () {
			this.tableSelectUtils.clear()
			this.getSum()
		},
		getSum () {
			let realpaymoneySum = 0
			let commissionmoneySum = 0
			this.ids.forEach(item => {
				commissionmoneySum = commissionmoneySum + (+item.commissionmoney)
				realpaymoneySum = realpaymoneySum + (+item.realpaymoney)
			})
			this.realpaymoneySum = realpaymoneySum
			this.commissionmoneySum = commissionmoneySum
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id,
				realpaymoney: row.realpaymoney,
				commissionmoney: row.commissionmoney
			}
		},
		summmaryMethod (param) {
			let { columns } = param
			let sums = []
			columns.forEach((column, index) => {
				if (index === 1) {
					sums[index] = '勾选合计'
					return false
				}
				if (column.property === 'realpaymoney') {
					sums[index] = this.realpaymoneySum
				}
				if (column.property === 'commissionmoney') {
					sums[index] = this.commissionmoneySum
				}
			})
			this.$nextTick(() => {
				this.$refs.table.doLayout()
			})
			return sums
		},
		// 跳订单
		goOrderDetail (row) {
			let orderParams = {}
			orderParams.orderId = row.orderid
			orderParams.statusId = row.statusId
			orderParams.differ = row.differ
			orderParams.buypullstate = row.buypullstate
			switch (row.orderStatus) {
			case 0:
				orderParams.billState = '待付款'
				break
			case 1:
				orderParams.billState = '待接单'
				break
			case 2:
				orderParams.billState = '待发货'
				break
			case 3:
				orderParams.billState = '待收货'
				break
			case 4:
				orderParams.billState = '已完成'
				break
			case 5:
				orderParams.billState = '已取消'
				break
			}
			window.sessionStorage.setItem('orderInfo', JSON.stringify(orderParams))
			let tabInfo = {}
			tabInfo.active = orderParams.billState
			tabInfo.isSellerpull = false
			tabInfo.orderStatus = row.orderStatus
			window.sessionStorage.setItem('tabInfo', JSON.stringify(tabInfo))
			this.$fxGoBlank('/blankdetail', this.$router)
		},
		// 跳退单
		goRefundOrderDetail (row) {
			let a = JSON.stringify(row)
			window.sessionStorage.setItem('refundOrderParams', a)
			this.$fxGoBlank('/blankRefundDetail', this.$router)
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.getSum()
			let list = this.ids
			let selectIds = list.map(item => {
				return item.id
			})
			this.$emit('selectIds', selectIds)
		},
		sortChangeHandle (data) {
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		},
		// 勾销
		liquidate (row, type) {
			let params = {
				liquidateflag: type,
				commissionResultIds: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		// 审核
		auditing (row, type) {
			let params = {
				auditingflag: type,
				commissionResultIds: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/auditingflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('审核失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.product-name {
			display: flex;
			justify-content: center;
			align-items: center;
			.giftLogo{
				margin-right :5px;
				font-size :10px;
				width: 24px;
				height: 18px;
				line-height: 18px;
				color: var(--fx-primary-color);
				border: 1px solid var(--fx-primary-color);
				border-radius :5px;
				flex-shrink: 0
			}
			.p-name {
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.under-num {
		cursor :pointer;
		color: var(--fx-primary-color);
		text-decoration: underline
		display: flex;
		align-items: center;
	}
	.under-num1 {
		color: var(--fx-primary-color);
		display: flex;
		align-items: center;
		span {
			cursor :pointer;
			text-decoration: underline
		}
		.return-icon {
			margin-left :5px;
			font-size :10px;
			width: 20px;
			height: 18px;
			line-height: 16px;
			color :#EC4141;
			border :1px solid #EC4141;
			border-radius :5px;
			flex-shrink: 0
		}
	}
}
</style>
s
